import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Section, Card, Button } from '../components/ui';
import consultingImage from '../assets/images/home-consulting.jpg';
import capitalImage from '../assets/images/home-capital.jpg';
import technologyImage from '../assets/images/home-technology.jpg';
import mslogo from '../assets/images/MSMlogo_white.png';
import './Services.css';

const services = [
    {
        title: 'Consulting',
        description: 'Change management consulting—from strategy to adoption in the workflow.',
        detailPath: '/services/consulting',
        image: consultingImage,
        imageAlt: 'Frosted glass panels with an abstract process graph on a light oak table',
    },
    {
        title: 'Capital',
        description: 'Angel investing and private equity with aligned governance and milestones.',
        detailPath: '/services/capital',
        image: capitalImage,
        imageAlt: 'Stacked translucent glass blocks suggesting compound growth',
    },
    {
        title: 'Technology',
        description: 'Automation, AI, and analytics tools we deliver and build for your decisions.',
        detailPath: '/services/technology',
        image: technologyImage,
        imageAlt: 'Macro photograph of fibre-optic strands catching daylight',
    },
];

const Services = () => {
    const navigate = useNavigate();

    return (
        <Section id="business-lines" variant="default" className="services-section anchor-target">
            <div className="services-wrapper">
                <motion.h2
                    className="services-heading"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: '-100px' }}
                    transition={{ duration: 0.6 }}
                >
                    <span className="services-heading-primary">What we offer.</span>
                    <span className="services-heading-secondary"> Consulting, capital, and technology.</span>
                </motion.h2>

                <div className="services-container">
                    {services.map((service, index) => (
                        <motion.div
                            key={service.title}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: '-50px' }}
                            transition={{ duration: 0.6, delay: index * 0.08 }}
                        >
                            <Card variant="interactive" className="services-card">
                                <div className="services-image-wrapper">
                                    <img
                                        src={service.image}
                                        alt={service.imageAlt}
                                        className="services-image"
                                    />
                                    <div className="services-image-overlay" />
                                </div>

                                <div className="services-content">
                                    <div className="services-logo-wrapper">
                                        <img
                                            src={mslogo}
                                            alt="MotionSpace"
                                            className="services-logo"
                                        />
                                    </div>

                                    <h3 className="services-title">{service.title}</h3>

                                    <p className="services-description">{service.description}</p>

                                    <div className="services-button-row">
                                        <Button
                                            variant="primary"
                                            size="md"
                                            onClick={() => navigate(service.detailPath)}
                                            className="services-button"
                                        >
                                            Learn more
                                        </Button>
                                        <Button
                                            variant="outline"
                                            size="md"
                                            onClick={() => navigate('/contact')}
                                        >
                                            Contact
                                        </Button>
                                    </div>
                                </div>
                            </Card>
                        </motion.div>
                    ))}
                </div>
            </div>
        </Section>
    );
};

export default Services;
